import Decimal from 'decimal.js';
import { vatPercent } from 'src/helpers/constants';

export const CENTS_IN_ONE_RAND = 100;
export const THE_NUMBER_ONE = 1;
export const ZAR_DECIMAL_PLACES_FOR_MINOR_UNITS = 2;
export const ZAR_CURRENCY_SYMBOL = 'R';
export const VAT_PERCENTAGE = 0.15;

const currencyFormatter = new Intl.NumberFormat('en', {
  minimumFractionDigits: ZAR_DECIMAL_PLACES_FOR_MINOR_UNITS,
  maximumFractionDigits: ZAR_DECIMAL_PLACES_FOR_MINOR_UNITS,
  useGrouping: false,
});

const currencyFormatterNoMandatoryTrailingZeros = new Intl.NumberFormat('en', {
  minimumFractionDigits: 0,
  maximumFractionDigits: ZAR_DECIMAL_PLACES_FOR_MINOR_UNITS,
  useGrouping: false,
});

export function getPriceWithVAT(priceExcludingVAT?: number): number {
  if (priceExcludingVAT) {
    Decimal.set({ rounding: Decimal.ROUND_HALF_UP });
    const totalPriceInCentsDecimal = new Decimal(priceExcludingVAT);
    const vatDecimal = new Decimal(THE_NUMBER_ONE + VAT_PERCENTAGE);

    const result = totalPriceInCentsDecimal.times(vatDecimal).round().toNumber();
    return result;
  } else {
    return 0;
  }
}

export function getTotalPriceInRands(totalPriceInCents: number): number {
  const totalPriceInCentsDecimal = new Decimal(totalPriceInCents);
  const centsInRandDecimal = new Decimal(CENTS_IN_ONE_RAND);
  const result = totalPriceInCentsDecimal
    .dividedBy(centsInRandDecimal)
    .toDecimalPlaces(ZAR_DECIMAL_PLACES_FOR_MINOR_UNITS, Decimal.ROUND_HALF_UP)
    .toNumber();
  return result;
}

/**
    Formats a ZAR currency amount in cents to a string
    where the amount is in rands, and excludes VAT.
    Also uses trailing zeros if after converting to rands,
    there are any cent component.

    @param amountInCents - ZAR currency amount in cents
 */
export const formatCurrencyAmount = (amountInCents?: number): string => {
  const amountInRands = amountInCents ? amountInCents / CENTS_IN_ONE_RAND : 0;

  const isInteger =
    amountInRands === null ||
    ((!!amountInRands || amountInRands === 0) && Math.floor(amountInRands) === amountInRands);
  let formatted;
  if (isInteger) {
    formatted = currencyFormatterNoMandatoryTrailingZeros.format(amountInRands);
  } else {
    formatted = currencyFormatter.format(amountInRands);
  }
  return formatted !== 'NaN' ? formatted.replace(/,(?=\d*(\.|,|$))/g, ' ') : amountInRands;
};

export const getAmountExcludingVAT2DP = (priceWithVat: number) =>
  Number((priceWithVat / (1 + vatPercent)).toFixed(2));

export const getAmountExcludingVAT = (priceWithVat: number) =>
  Math.round(priceWithVat / (1 + vatPercent));

export const getAmountOfVAT = (priceWithVat: number) =>
  priceWithVat - getAmountExcludingVAT(priceWithVat);
